import { Button, Stack } from 'component-library';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { PlotGroup } from '@/api/rest/resources/types/plotGroup';
import { User } from '@/api/rest/resources/types/user';
import { Icon } from '@/components/widgets/a/Icon/Icon';
import { EditLimitedAccessOrganization } from '@/pages/shared/components/plot-group/EditLimitedAccessOrganization';
import { assertIsDefined } from '@/utils/assert';

export const CreateLimitedAccessOrganization = ({
  organizationId,
  plotGroups,
  users,
}: {
  organizationId: string;
  plotGroups?: PlotGroup[];
  users?: User[];
}) => {
  const { t } = useTranslation();
  const [isAddingLimitedAccessPlotGroup, setIsAddingLimitedAccessPlotGroup] = useState(false);

  assertIsDefined(organizationId, 'organizationId');

  return (
    <Stack className='flex flex-row justify-end'>
      <Button
        variant='outline'
        onClick={() => setIsAddingLimitedAccessPlotGroup(true)}
        leftAdornment={<Icon icon='ri-account-circle-line' className='w-5 p-0 m-0 text-primary-100' />}
      >
        {t('global.organization.limitedAccessOrganization.createLimitedAccessOrganization.buttonLabel')}
      </Button>
      <EditLimitedAccessOrganization
        organizationId={organizationId}
        open={isAddingLimitedAccessPlotGroup}
        onOpenChange={(open) => setIsAddingLimitedAccessPlotGroup(open)}
        plotGroups={plotGroups}
        users={users}
      />
    </Stack>
  );
};
